import { createModel } from '@rematch/core';
import produce from 'immer';

import { RootModel } from '../models';

export const storeName = 'app';

const initialState = {
  // LAYOUT STATE
  layoutState: {
    isMenuTop: false,
    menuMobileOpened: false,
    menuCollapsed: true,
    menuShadow: false,
    themeLight: localStorage.getItem('cvta.theme') === 'light',
    squaredBorders: false,
    borderLess: true,
    fixedWidth: false,
    settingsOpened: false,
  },

  isMobileDevice: false,
  isTabletDevice: false,
  // USER
  user: {},
};

export const app: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    enableLigthTheme: produce((state, payload) => {
      state.layoutState.themeLight = payload;
    }),
    collapseMenu: produce((state, payload) => {
      state.layoutState.menuCollapsed = payload;
    }),
    setMobileDevice: produce((state, payload) => {
      state.isMobileDevice = payload;
      state.layoutState.menuCollapsed = true;
    }),
    setTabletDevice: produce((state, payload) => {
      state.isTabletDevice = payload;
    }),
  },
});

export default app;
